import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Config {
    url?: string,
    urlImagem?: string,
    urlRelativa?: string,
}

const inicial: Config = {};

export const config = createSlice({
    name: 'config',
    initialState: inicial,
    reducers: {
        carregar: (estado, acao: PayloadAction<Config>) => estado = acao.payload,
    }
});

export const { carregar } = config.actions;

export default config.reducer;
